/**
 * Модель для настроек сервисов (детектор падений, детектор неподвижности)
 */

import { createModel } from '@rematch/core';
import { RootModel } from './index';

import AdminService from '../services/AdminService';
import { IFallSettings, IAccStillSettings } from './types';

interface IState {
  data: IFallSettings | null;
  loading: boolean;
  accStill: IAccStillSettings | null;
  accStillLoading: boolean;
}

const initialState: IState = {
  data: null,
  loading: false,
  accStill: null,
  accStillLoading: false
};

export const settingServices = createModel<RootModel>()({
  state: initialState,
  reducers: {
    setData(state: IState, payload: IFallSettings | null): IState {
      return { ...state, data: payload };
    },
    setLoading(state: IState, payload: boolean): IState {
      return { ...state, loading: payload };
    },
    setAccStill(state: IState, payload: IAccStillSettings | null): IState {
      return { ...state, accStill: payload };
    },
    setAccStillLoading(state: IState, payload: boolean): IState {
      return { ...state, accStillLoading: payload };
    },
    reset(): IState {
      return { ...initialState };
    }
  },
  effects: () => ({
    async getFallSettings() {
      try {
        this.setLoading(true);
        const { data } = await AdminService.getFallSettings();
        this.setData(data);
        this.setLoading(false);
      } catch (error) {
        this.setLoading(false);
        return error;
      }
    },
    async getAccStillSettings() {
      try {
        this.setAccStillLoading(true);
        const { data } = await AdminService.getAccStillSettings();
        this.setAccStill(data);
        this.setAccStillLoading(false);
      } catch (error) {
        this.setAccStillLoading(false);
        return error;
      }
    },
    // Эффекты сохранения возвращают ответ целиком: статус PUT значим для UI
    // (200 — сохранено, 202 — применено без записи, ошибка — в error.response)
    async saveFallSettings(payload: IFallSettings) {
      try {
        return await AdminService.saveFallSettings(payload);
      } catch (error) {
        return error;
      }
    },
    async saveAccStillSettings(payload: IAccStillSettings) {
      try {
        return await AdminService.saveAccStillSettings(payload);
      } catch (error) {
        return error;
      }
    }
  })
});
